/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import classNames from 'classnames';
/**
 * Breadcrumb 面包屑
 */
export class Breadcrumb {
/**
 * 样式前缀
 */
prefixCls = 'ant-breadcrumb';
/**
 * 用户CSS样式
 */
class: string;

     separator = '/';
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * 样式
 * @return {?}
 */
get classes(): string {
        return classNames(this.prefixCls, this.class);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-breadcrumb',
    template: '<ng-content></ng-content>',
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'class': [{ type: Input },],
'separator': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Breadcrumb_tsickle_Closure_declarations() {
/** @type {?} */
Breadcrumb.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Breadcrumb.ctorParameters;
/** @type {?} */
Breadcrumb.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Breadcrumb.prototype.prefixCls;
/**
 * 用户CSS样式
 * @type {?}
 */
Breadcrumb.prototype.class;
/** @type {?} */
Breadcrumb.prototype.separator;
/** @type {?} */
Breadcrumb.prototype.renderer;
/** @type {?} */
Breadcrumb.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
